import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Spinner from "../../Components/Spinner/Spinner";
import axios from "axios";
import { toast } from "react-toastify";
import { parseJwt } from "../../utils/parseJwt";
import baseUrl from "../../baseUrl";
import moment from "moment";
import AddComment from "../../Components/AddComment/AddComment";
import CommentList from "../../Components/CommentList/CommentList";

const SingleBlog = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [blog, setBlog] = useState({});
  const [blogImage, setBlogImage] = useState("");
  const [avatar, setAvatar] = useState({});
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [comments, setComments] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/blog/blog-details`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          setBlog(response.data.blog);
          setBlogImage(response.data.blog.image);
          setAvatar(response.data.blog.userId.avatar);
          setUser(response.data.blog.userId);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, [id, token]);

  const handleBlogDelete = (blogId) => {
    const userId = parseJwt(token).id;
    axios
      .post(
        `${baseUrl}/blog/delete-blog`,
        { id: blogId, userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response.data.message);
          navigate("/");
        } else {
          toast.error(response.data.message);
          navigate(`/blog-details/${id}`);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/comment/get-comment`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setComments(res.data.comments);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, token]);
  return (
    <>
      {loading && <Spinner />}
      <BreadCrumb
        textOne={"Home"}
        linkOne={"/"}
        textTwo={"Profile"}
        linkTwo={"/profile"}
        textThree={"Blog Details"}
      />
      <div draggable="false" className="max-w-screen-xl mx-auto">
        <main className="mt-1">
          <Link className="text-indigo-700 " to={`/other-user/${user._id}`}>
            <div
              className="mb-4 md:mb-0 w-full max-w-screen-md mx-auto relative"
              style={{ height: "24em" }}
            >
              <div
                className="absolute rounded-md left-0 bottom-0 w-full h-full z-10"
                style={{
                  backgroundImage:
                    "linear-gradient(180deg,transparent,rgba(0,0,0,.7))",
                }}
              ></div>
              <img
                src={blogImage["url"]}
                className="absolute left-0 top-0 w-full h-full z-0 object-cover"
                alt="blog"
              />
              <div className="p-4 absolute bottom-0 left-0 z-20">
                <Link
                  to=""
                  className="px-4 py-1 bg-black text-gray-200 inline-flex items-center justify-center mb-2"
                >
                  {blog.category}
                </Link>
                <h2 className="text-4xl font-semibold text-gray-100 leading-tight">
                  {blog.title}
                </h2>
                <div className="flex mt-3">
                  <img
                    src={avatar["url"]}
                    className="h-10 w-10 rounded-full mr-2 object-cover"
                    alt="user-avatar"
                  />
                  <div>
                    <p className="font-semibold text-gray-200 text-sm">
                      {user.fullName}
                    </p>
                    <p className="font-semibold text-gray-400 text-xs">
                      {moment(blog.createdAt).fromNow()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>

          <div className="px-4 lg:px-0 mt-12 text-gray-700 max-w-screen-md mx-auto text-lg leading-relaxed">
            <div className="flex justify-between">
              <div className="flex">
                <span className="text-gray-400 mr-3 inline-flex items-center leading-none text-sm">
                  <i className="w-4 h-4 mr-1 fa-solid fa-eye"></i>
                  {blog.views}
                </span>

                <span className="text-gray-400 inline-flex items-center leading-none text-sm">
                  <i className="w-4 h-4 mr-1 fa-solid fa-comment"></i>
                  {blog.comments}
                </span>
              </div>

              {token && user._id === parseJwt(token).id && (
                <div className="flex">
                  <Link
                    to={`/update-blog/${blog._id}`}
                    className="cursor-pointer  text-green-400 pr-3 inline-flex items-center leading-none text-sm"
                  >
                    <i className="w-4 h-4 mr-1 fa-solid fa-pen-to-square"></i>
                  </Link>
                  <span
                    onClick={() => {
                      handleBlogDelete(blog._id);
                    }}
                    className="text-red-400 cursor-pointer inline-flex items-center leading-none text-sm"
                  >
                    <i className="w-4 h-4 mr-1 fa-solid fa-trash"></i>
                  </span>
                </div>
              )}
            </div>
            <div
              className="pb-6"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
          </div>

          <AddComment id={blog._id} />

          {comments &&
            comments.map((comment) => (
              <CommentList
                key={comment._id}
                Id={blog._id}
                comment={comment}
                userId={parseJwt(token).id}
                token={token}
                nav="blog"
              />
            ))}
        </main>
      </div>
    </>
  );
};

export default SingleBlog;
